import { createRoute } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const IntegrityRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/integrity',
}).lazy(() =>
  import('./IntegrityRoute.lazy').then((d) => d.LazyIntegrityRoute),
);
